export const EMPTY_STRING = "";

export const PatternConstant = {
  DATE_FORMAT: 'dd/mm/yy'
};
export const rolesToCheck = ['ROLE_COURTIER'];

export const ScaleConstant = {
  SCALE_DELAY: 50,
  INITIAL_SCALE_DELAY: 100,
  DATA_LOAD_SCALE_DELAY: 200,
  MIN_TEXT_SCALE: 0.7,
  MIN_IMAGE_SCALE: 0.55,
  OVERFLOW_THRESHOLD: 1.0,
  MILD_OVERFLOW: 1.5,
  MODERATE_OVERFLOW: 2.5,
  HEAVY_OVERFLOW: 4.0
};